// NATIVE 
import * as React from 'react';


// INSTALLED 
import { Grid } from '@mui/material';
import { Formik, Form } from 'formik';
import { useSelector } from 'react-redux';
import Dialog from '@mui/material/Dialog';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';


// CUSTOM 
import { useDispatch } from 'react-redux';
import { SnackAlert } from '../../SnackAlert';
import MultipleSnackbars from '../../MultipleSnackbars';
import { CrearTurno } from '../../turnos/crear/CrearTurno';
import { ModalSessionExpired } from '../../generics/ModalSessionExpired';
import { closeSessionGlobal, hasPemissions } from '../../../commons/utils';
import validationSchema from '../../turnos/formModels/crear/validationSchema';
import formInitialValues from '../../turnos/formModels/crear/formInitialValues';
import createTurnoFormModel from '../../turnos/formModels/crear/createTurnoFormModel';
import { showDaysWeekCreateShiftError, storeCreateTurno } from '../../../store/shifts';
import { timeToClosedToast } from '../../../commons';







const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));




/**
 * CreateDialogTurno component is responsible for rendering a dialog to create a new shift (turno).
 * It utilizes various hooks such as useDispatch, useSelector, and useState to manage state and dispatch actions.
 * 
 * @param {object} props - The properties passed to the component.
 * @param {boolean} props.open - Determines if the dialog is open.
 * @param {function} props.handleCloseDialogCrearTurno - Function to handle closing the dialog.
 * @param {boolean} [props.buttons=false] - Optional prop to determine if buttons should be displayed.
 * 
 * @returns {JSX.Element} The rendered CreateDialogTurno component.
 * 
 * @example
 * <CreateDialogTurno 
 *   open={true} 
 *   handleCloseDialogCrearTurno={handleClose} 
 *   buttons={true} 
 * />
 */
export const CreateDialogTurno = (props:any) =>  {


  // USE DISPATCH 
  const dispatch = useDispatch();

  
  // USE SELECTOR 
  const { cargo, cargos_list }:any  = useSelector( (state:any) => state.cargos );


  // USE STATE 
  const  [btnText, setBtnText] = React.useState('Crear Turno');
  const  [dataCargo, setDataCargo] = React.useState<any>(null);
  const  [isSubmitting, setIsSubmitting] = React.useState(false);

  
  const [data, setMsgErrors] = React.useState([]);
  const [areas_select, setAreasSelect] = React.useState([]);
  const [percentaje_area, setPercentajeArea] = React.useState(0);
  const [message_alert_snack, setMessageAlertSnack] = React.useState('');
  const [type_alert_snack, setTypeAlertSnack] = React.useState('success');

  const [timeAlert, setTimeAlert] = React.useState(timeToClosedToast);
  const [messagesAlerts, setMessagesAlerts] = React.useState<any>([]);

  const [modalSessionExpired, setModalSessionExpired] = React.useState<boolean>(false);

  const [alert_snack, setAlertSnack] = React.useState(false);
  const [msgSnack, setMsgSnack] = React.useState({
      msg: '',
      status: 'success'
  });

 

  // PROPS 
  const{ open, handleCloseDialogCrearTurno, buttons = false } = props;


  // DATA MODEL 
  const { formId, formField } = createTurnoFormModel;


  // VALIDATION SCHEMA 
  const currentValidationSchema = validationSchema[0];

  

  // USE EFFECT 
  React.useEffect(() => {
    setDataCargo(cargo);
  }, [cargo]);


  React.useEffect(() => {


    const cargos:any = [];



    if ( cargos_list ) {

      for (let index = 0; index < cargos_list.length; index++) {
        
        const data = {
           label: cargos_list[index].name,
           value: cargos_list[index].id
        }
        cargos.push(data);
     
      }
      setAreasSelect(cargos);
      
    }

    

 }, [cargos_list]);

  

  // CONST FUNCTIONS 
  const handleCloseT = () => {
    handleCloseDialogCrearTurno(false);
  };


  const _handleSubmit = async(values:any, actions:any) => {


    if ( !values.lunes && !values.martes && !values.miercoles && !values.jueves && !values.viernes && !values.sabado && !values.domingo && !values.festivo ) {
      
          await dispatch( showDaysWeekCreateShiftError() );
          return false;
    }
     
   
   

    const havePermissions = await hasPemissions('modulo.thumano', 'modulo.turnos', 'create');


    if( !havePermissions ){


      await validateLsPermissions('No tienes pemisos para (Crear) turnos.');

      return false; 
                                                            
        
    }

    setIsSubmitting(true);
    setBtnText('Un momento...')

    actions.setSubmitting(true);

    

    const response = await dispatch( storeCreateTurno(values, setPercentajeArea) );


    const result = await validateResponseCreate(response, ' (Crear Turno) ');


    setIsSubmitting(false);
    setBtnText('Crear Turno')


    if ( response.ok ) {

      const errors:any = {
        msg: response.message,
        status: 'success'
      };
    
      await setMsgSnack(errors);
      await setAlertSnack(true);

      actions.resetForm();
      actions.setSubmitting(false);
      handleCloseDialogCrearTurno(false);
      return false;

    }

    
    

  }



  const validateLsPermissions = async(message:string) => {

    const errors:any = {
      msg: message,
      status: 'error'
    };
  
    await setMsgSnack(errors);
    await setAlertSnack(true);
  
  
  }



  const validateResponseCreate = async(response:any, textActionConcat: string) => {
          
          
      if (  response.code == 401  ) {
        await localStorage.removeItem('lastSelectedQypht');
        await closeSessionGlobal();
        await handleCloseDialogCrearTurno(false);
        setModalSessionExpired(true);
        return false;
      }

    
      // 403 NO TIENE PERMISSO PARA REALIZAR ESA ACCION 
      if (!response.ok && response.code == 403 ) { 

      
        const errors:any = {
          msg: response.errors[0]+' '+textActionConcat,
          status: 'error'
        };
      
        await setMsgSnack(errors);
        await setAlertSnack(true);

      
        return false;
        
      }


      // 403 EL DATO YA SE ENCUENTRA REGISTRADO
      if (!response.ok && response.code == 409 ) { 
    
        const errors:any = {
            msg: response.errors[0]+' '+textActionConcat,
            status: 'error'
        };
        
        await setMsgSnack(errors);
        await setAlertSnack(true);

        return false;
      }

      
      // 400 ERROR EN DATOS ENVIADOS MAYORMENTE PROPIEDAD INVALIDA O MAL FORMATEADO 
      if (!response.ok && response.code == 400 ) { 

        const errors:any = [];

        response.errors.forEach( (element:any) => {
            
            errors.push({
              type: 'error',
              text: element
            })
        });

          
        setMessagesAlerts(errors);
        return false;

      }

      return true;
    
  } 




  return (
    <React.Fragment>

     
      <ModalSessionExpired  open={modalSessionExpired}  />
      
      <MultipleSnackbars messagesList={messagesAlerts} position={"bottom-left"} autoClose={timeAlert} />

      <SnackAlert open={alert_snack} onclick={setAlertSnack} text={msgSnack.msg} severity={msgSnack.status}/>

      
      <BootstrapDialog
        onClose={handleCloseT}
        aria-labelledby="customized-dialog-title"
        open={open}
        fullWidth={true}
      >
        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
           Crear Turno 
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleCloseT}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent dividers>
        
   
        <Grid  >
            <Formik 
              initialValues={formInitialValues}
              validationSchema={currentValidationSchema}
              onSubmit={_handleSubmit}>

              <>
                 <Form id={formId}>
                 <CrearTurno formField={formField}/>
                  
                  <Button
                    disabled={isSubmitting}
                    style={{margin:5, float: 'right'}}
                    type="submit"
                    variant="contained"
                    color={ "primary"}
                  >
                    {
                      btnText
                    } 
                </Button>
                </Form>
              </>

            </Formik>
        </Grid>
       
        </DialogContent>
        <DialogActions>
        </DialogActions>
      </BootstrapDialog>
    </React.Fragment>
  );
}